<template>
  <div class="success-page">

    <div class="card">

      <div class="icon">✅</div>

      <h1>Payment Successful</h1>

    </div>

  </div>
</template>

<script>
export default {
  methods: {
    goToApp() {
      window.location.href = "https://app.nocodeagent.ai/login";
    }
  }
};
</script>

<style scoped>
.success-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fafb;
  font-family: Inter, sans-serif;
}

.card {
  background: white;
  padding: 50px;
  border-radius: 20px;
  text-align: center;
  width: 420px;
  box-shadow: 0 30px 80px rgba(0,0,0,0.15);
}

.icon {
  font-size: 60px;
  margin-bottom: 20px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.subtitle {
  color: #6b7280;
  margin-bottom: 25px;
}

.details {
  text-align: left;
  margin-bottom: 30px;
}

.details ul {
  padding-left: 20px;
}

.primary-btn {
  background: #2563eb;
  color: white;
  padding: 14px 30px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  margin-bottom: 20px;
}

.primary-btn:hover {
  background: #1d4ed8;
}

.small {
  font-size: 0.85rem;
  color: #9ca3af;
}
</style>